export default __webpack_public_path__ + "static/media/dazn.link-yellow.233d280c.png";